export default "__VITE_ASSET__Dk5obZo5__"